import { Model } from 'modules/core/lib/mobx-rest'

interface IPublicHoliday {
  [key: string]: any
}
class PublicHoliday extends Model<IPublicHoliday> {
  static urlRoot() {
    return '/public_holidays'
  }
}

export default PublicHoliday
